export const API_URL = process.env["REACT_APP_API_URL"];

export const ENVIRONMENT =
  (process.env["REACT_APP_ENVIRONMENT"] as "develop" | "testing" | "main") ||
  "develop";

export const DNA_BE_FILEPATH = process.env["REACT_APP_DNA_BE_FILEPATH"];
export const DNA_BE_FILEPATH_NAME =
  process.env["REACT_APP_DNA_BE_FILEPATH_NAME"];
export const DNA_INDEX_FILEPATH_NAME =
  process.env["REACT_APP_DNA_INDEX_FILEPATH_NAME"];
export const IGV_HOST_URL = process.env["REACT_APP_IGV_HOST"];
export const USER_ID = "user_1";
export const BASE_PATH = process.env["PUBLIC_URL"] || "";
export const ROWS_PER_PAGE = (
  process.env["REACT_APP_ROWS_PER_PAGE"] || "15,30,50"
).split(",");
export const CRIPSER_PATH = process.env["REACT_APP_CRISPER_URL"] || "/";
export const SHOW_FOOTER =
  process.env["REACT_APP_SHOW_FOOTER"] === "true" || false;
export const SHOW_HEADER =
  process.env["REACT_APP_SHOW_HEADER"] === "true" || false;

export const SENTRY_DNS =
  process.env["REACT_APP_SENTRY_DNS"] ||
  "https://a7b9638e31b22a91e4cadedd81862150@sentry.merckgroup.com/18";

export const SENTRY_ENV = process.env["REACT_APP_SENTRY_ENV"] || "dev";

export const isShowNotification =
  process.env["REACT_APP_SHOW_NOTIFICATION"] || false;

export const notificationMessage = process.env["REACT_APP_NOTIFICATION_MSG"];

export const firstNotification =
  typeof process.env["REACT_APP_FIRST_NOTIFICATION"] === "string"
    ? JSON.parse(process.env["REACT_APP_FIRST_NOTIFICATION"])
    : {};

export const secondNotification =
  typeof process.env["REACT_APP_SECOND_NOTIFICATION"] === "string"
    ? JSON.parse(process.env["REACT_APP_SECOND_NOTIFICATION"])
    : {};

export const SIGMA_IMPORT_URL =
  process.env["REACT_APP_SIGMA_IMPORT_URL"] ||
  "https://wwwdws.sigmaaldrich.com/genomics/import-sequences";

export const excelTopLink =
  typeof process.env["REACT_APP_EXCEL_TOP_ROW"] === "string"
    ? JSON.parse(process.env["REACT_APP_EXCEL_TOP_ROW"])
    : {};
